import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebase';
import './AllProducts.css'; // reuse card styles
import './ProductPage.css'

import { FaMinus, FaCircle, FaDatabase, FaExpandArrowsAlt } from "react-icons/fa";
import { PiPlugFill } from "react-icons/pi";



import { useNavigate } from 'react-router-dom'; // make sure this is at the top

export function superscriptRegistered(text) {
  if (!text) return '';
  return text.replace(/®/g, '<sup style="font-size:0.65em; vertical-align: super;">®</sup>');
}

const FIBER_PANEL_CONFIG = {
  heroIcons: [
    { label: "Terminate", icon: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2Fterminate.png?alt=media&token=dd9ea855-8427-4f69-a62f-e6a289d50900" },
    { label: "Splice", icon: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2Fsplice.png?alt=media&token=c9b036a0-2bc4-413e-a8ad-dab3355fda48" },
    { label: "Store", icon: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2Fstore.png?alt=media&token=02b881d3-c5e1-4a9f-862b-338a9a885c30" },
    { label: "Shuffle", icon: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2Fshuffle.png?alt=media&token=8c9eb99d-60a5-4fe6-bb7c-19746d2123d2" },
  ],

  exploreFilters: [
    "Patch and Splice Panels",
    "Patch Only Panels",
    "Fiber Storage",
    "Splice Only Chassis",
    "Accessories",
  ],

  featureCards: [
    { title: "Spreadable adapters", desc: "Improved port access", image: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FspreadableAdapters.png?alt=media&token=8ea79580-8f42-427f-8cad-bc5bf274a483" },
    { title: "Modular", desc: "Scale & upgrade easily", image: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2Fmodular.png?alt=media&token=f0ae20ad-e284-4475-8bb4-ec6d54f74ca5" },
    { title: "Soc sleeve", desc: "Protect & secure cables", image: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FsocSleeves.png?alt=media&token=26e5ace8-a2c1-4838-876f-c147345195f0" },
    { title: "Sliding cassettes", desc: "Front & rear access", image: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FSlidingAccess.png?alt=media&token=10e068a9-ba91-47ef-888a-1317689f6a90" },
    { title: "Port labeling", desc: "Aid techs, minimize errors", image: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FportLabeling.png?alt=media&token=4f559983-b784-47ba-8ac2-90c3dbe2a5a3" },
    { title: "Cable management", desc: "Radius limiters & routing guides", image: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FcableManagement.png?alt=media&token=cecf56dd-6c50-407c-ac0a-ac97438d2f20" },
    { title: "Notched mounting bracket", desc: "Protects & secures cables", image: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FnotchedMountingBracket.png?alt=media&token=f09f9c4f-3dea-4ea4-ae40-3ae951d2059e" },
    { title: "Stowable cassettes", desc: "Protects from accidental disconnects", image: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FstowableCassettes.png?alt=media&token=72a0d4ec-b7f1-4c85-95d9-a659c340bf2d" },
    { title: "Splice cassettes", desc: "Splice securely", image: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FspliceCassettes.png?alt=media&token=301e9379-d206-494a-a5fd-fd63b37e9bf3" },
  ],
};

const productFamilyBodyText = [
  {
    "name": "Fiber Cable Assemblies",
    "slug": "/fiber-cable-assemblies",
    "headline": "Fiber cable assemblies for tomorrow’s networks",
    "subHeadline": "Optical performance begins with every assembly",
    "bodyText": "Go!Foton offers a comprehensive range of MPO optical fiber patch cords and breakout cable assemblies designed for telecom and data center applications. Our state-of-the-art manufacturing process ensures every assembly delivers the performance and reliability demanded by today’s high-speed broadband and data networks. We guarantee industry-leading insertion and optimal reflectance loss on every cable assembly manufactured. Go!Foton utilizes world-class components, and our Telcordia and FOC-certified manufacturing facility ensures our products not only meet but exceed industry standards. With 100% of our products rigorously tested before shipping, Go!Foton stands behind each fiber cable assembly to ensure unmatched quality.",
    "subHeadline2": "Premium fiber assemblies that deliver"
  },
  {
    "name": "Passive Optical Components",
    "slug": "/passive-optical-components",
    "headline": "High-quality precision passive components to power fiber networks",
    "subHeadline": "Engineered for endurance in high-demand networks",
    "bodyText": "Go!Foton Passive Optical Components deliver foundational fiber-network elements - taps, couplers, splitters, WDMs, and custom configurations - designed for peak performance in telecom, CATV, and data centers, including outside-plant deployments. These components feature low insertion loss, minimal polarization-dependent loss, and exceptional thermal stability to preserve signal integrity under the toughest conditions. Engineered with epoxy-free, all-glass constructions, our passive components are optimized for high-power transmission and seamless sensor integration, they streamline installation, maintenance, and expansion. Backed by rigorous manufacturing standards, Go!Foton solutions maximize network uptime and ensure long-term reliability to meet evolving network demands.",
    "subHeadline2": "Passive optical components designed for seamless integration"
  },
  {
    "name": "Photodetectors",
    "slug": "/photodetectors",
    "headline": "Photodetectors built for precision, scale, and durability",
    "subHeadline": "Reliable detection in every channel, every time",
    "bodyText": "Go!Foton’s Photodetector portfolio delivers high-performance optical detection and power-monitoring solutions for fiber networks, offering single- and multi-channel integrated detectors alongside wafer-level photodiode chips tailored for Optoelectronics, Optical Equipment, and Specialty Optics applications. Combining high sensitivity and rapid response with rugged, hermetically sealed construction, our photodetector portfolio delivers accurate channel monitoring and reliable performance in the most demanding network environments. Go!Foton’s versatile photodetector suite empowers you to optimize signal quality and uptime while simplifying deployment and lifecycle support.",
    "subHeadline2": "High-performance devices for signal monitoring and power detection"
  },
  {
    "name": "Cassettes",
    "slug": "/cassettes",
    "headline": "Scalable, modular cassettes for dense fiber networks",
    "subHeadline": "Optimized for efficiency, built for evolution",
    "bodyText": "Go!Foton’s cassettes deliver a fully modular, field-reconfigurable building block for today’s densest fiber networks, combining craft-friendly accessibility with unmatched performance. Our family of cassettes works with Go!Foton’s innovative line of fiber panels enables rapid capacity scaling and dramatic SKU reduction. Featuring our patented PEACOC® spreadable-adapter technology, these compliant, low-loss cassettes simplify installation, moves, adds, and changes, minimizing labor costs and future-proofing your network against evolving bandwidth demands.",
    "subHeadline2": "Flexible cassettes for agile network deployments"
  },
  {
    "name": "Frames",
    "slug": "/frames",
    "headline": "PEACOC® Fiber Distribution Frames for high density",
    "subHeadline": "Designed for the demands of modern networks",
    "bodyText": "PEACOC Fiber Distribution Frames are an open-framed rack designed to mount a variety of fiber optic panels and equipment to accurately route, manage, and store large volumes of fiber cables for quick, easy, and safe turn-up of new services and connections.",
    "subHeadline2": "A flexible solution for every fiber configuration"
  },
  {
    "name": "Fiber Panels",
    "slug": "/fiber-panels",
    "headline": "Fiber Panels that Revolutionize Network Connectivity",
    "subHeadline": "Empower AI and Data Center connectivity",
    "bodyText": "Go!Foton Fiber Panels deliver scalable, high-density connectivity that simplifies fiber management across AI, data centers, telecommunications, and CATV networks. Designed to integrate seamlessly into standard rack and cabinet environments, they provide unobstructed access to connections for fast, error-free installation, maintenance, and moves, adds, and changes. Our family of Fiber Panels combines modular scalability, growth flexibility, and robust fiber routing, with many featuring Go!Foton’s patented PEACOC® Spreadable Adapter Technology, to meet evolving network demands without compromising performance, reliability, or industry compliance. Engineered for long-term durability and maximum port density, they empower operators to organize cable management, streamline deployments, optimize uptime, and confidently support future growth.",
    "subHeadline2": "Discover modular, scalable fiber panel solutions"
  },
  // {
  //   "name": "Fiber Splice Chassis",
  //   "slug": "/fiber-splice-chassis",
  //   "headline": "PEACOC® Splice Chassis for Demanding Networks",
  //   "subHeadline": "Innovative access for faster splice operations",
  //   "bodyText": "Go!Foton’s PEACOC Splice Chassis is a high-density, rack-mount enclosure engineered to securely store and manage fiber splices in demanding distribution networks. Our innovative sliding-and-rotating mechanism delivers full tray and cable access, streamlining both installation and ongoing maintenance.",
  //   "subHeadline2": "Explore the PEACOC Splice Chassis Series"
  // },
  {
    "name": "Fiber Network Monitoring",
    "slug": "/fiber-network-monitoring",
    "headline": "Fiber network monitoring in the AI era",
    "subHeadline": "Know your optical network in real-time",
    "bodyText": "In today’s high-density and mesh optical networks, every strand of fiber carries mission-critical information. Ensuring that infrastructure stays healthy, secure, and performing at its peak requires visibility without interrupting service or compromising security.\n  Go!Foton’s sensing-based fiber monitoring solutions are fully passive, real-time, and non-disruptive. They reveal conditions that many NOCs and conventional tools miss. By analyzing the fiber foundations of networks, operators and engineering firms are on the front-foot from planning to prioritizing and scheduling maintenance ahead of any outage. Optical sensing solutions deliver a new layer of intelligence for networks that can’t afford downtime.\n Our optical sensing solutions are bespoke and industry-leading, designed to deliver deep visibility into fiber networks. They integrate seamlessly with any optical infrastructure, enabling operators to deploy advanced monitoring regardless of their network architecture.",
    "subHeadline2": "Optical sensing solutions like no other"
  },
  {
    "name": "Fiber Terminals & Closures",
    "slug": "/fiber-terminals-&-closures",
    "headline": "Scalable, Future-Ready Fiber Terminals and Closures",
    "subHeadline": "Streamlined fiber distribution across OSP and premises",
    "bodyText": "The Go!Foton Fiber Terminals and Closures portfolio provides compact, weatherproof enclosures for streamlined fiber distribution across outside-plant and premise applications, from rural FTTx drop networks to high-density MDU and wireless backhaul. Designed for plug-and-play or field-splice termination with standard connectors, these solutions enable rapid, error-free turn-up backed by industry-rated protections. Terminals featuring modular trays and our patented PEACOC® Spreadable Adapter Technology support splitters, taps, and splices, simplifying maintenance and scaling. Universal mounting options fit any pole, strand, wall, or handhole installation while accommodating evolving network architectures. Go!Foton’s versatile lineup accelerates deployment, maximizes uptime, and future-proofs fiber infrastructure investments.",
    "subHeadline2": "Discover modular Go!Foton Fiber Terminals and Closures solutions"
  },
  {
    "name": "Lenses",
    "slug": "/lenses",
    "headline": "Precision Lenses",
    "subHeadline": "Precision GRIN Lens Solutions for advanced optical applications",
    "bodyText": "Go!Foton gradient index (GRIN) lenses provide high-performance optical solutions for a wide variety of applications, ranging from beam coupling and telecommunications to range-finding and advanced imaging systems. They support microscopy, endoscopy, and OCT with the precision and efficiency required across research, medical, industrial, and communications fields. \nGo!Foton SELFOC® Lens Arrays, long an industry standard in printing and scanning systems, deliver consistent optical performance for modern biomedical imaging and machine vision, enabling compact, high-resolution imaging across diverse technologies. \nGo!Foton lenses are available in standard and custom lengths, in multiple lens families, and a variety of diameters to support diverse integration requirements. Specialized coatings and custom optical configurations are also available upon request to meet unique application and performance needs.",
    "subHeadline2": "Explore Go!Foton’s lens portfolio"
  },
  {
    "name": "Collimators & Probes",
    "slug": "/collimators-&-probes",
    "headline": "Collimators and Probes Optimize to Fiber Optic Performance",
    "subHeadline": "Engineered for precision beam collimation and coupling",
    "bodyText": "Go!Foton Collimators and Probes leverage gradient-index lens technology to deliver compact solutions for beam collimation, coupling, and focusing. With customizable beam profiles, focal positions, and waist diameters, our solutions integrate seamlessly into fiber-optic networks, precision instrumentation, WDM modules, and optical switches. Engineered for scalable production, Go!Foton Collimators and Probes’ adaptable configurations ensure alignment stability, spectral uniformity, and throughput in a variety of fiber network and sensing applications.",
    "subHeadline2": "Discover Go!Foton’s Collimators and Probes solutions"
  },
  {
    "name": "Transceivers",
    "slug": "/transceivers",
    "headline": "Transceivers Designed for the Next Wave of Optical Innovation",
    "subHeadline": "Purpose‑built to support dense traffic growth, AI workloads, and the evolving demands of cloud and carrier environments.",
    "bodyText": "Go!Foton’s transceiver portfolio is engineered to meet the escalating performance demands of next‑generation optical networks, delivering the power, precision, and flexibility required for AI‑driven data centers, high‑capacity transport, and advanced access architectures. Our product family spans cutting‑edge burst‑mode solutions for PON and upstream applications, high‑speed 400G, 800G, and 1.6T modules for core and metro transport, innovative co‑packaged optics that bring photonics directly onto the switch ASIC, and external‑laser pluggable platforms that unlock new levels of scalability for silicon photonics systems. Together, these technologies give network designers a complete toolkit to increase bandwidth, reduce power consumption, simplify integration, and accelerate deployment across a wide range of environments.",
    "subHeadline2": "Discover Go!Foton’s Transceiver solutions"
  }
]

const ProductFamilyPage = () => {
    const navigate = useNavigate(); // inside the component

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

  const { slug, familySlug } = useParams();
  const resolvedFamilySlug = familySlug || slug;
  const matchingFamilyText = productFamilyBodyText.find(p => 
    p.slug.replace('/', '') === resolvedFamilySlug
  );
  const [productsBySubFamily, setProductsBySubFamily] = useState({});
  const [familyName, setFamilyName] = useState('');
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [activeFilter, setActiveFilter] = useState('All');
  const [productFamilies, setProductFamilies] = useState([]);
  const [topProductImage, setTopProductImage] = useState(null);


  useEffect(() => {
    const fetchProducts = async () => {
      const snap = await getDocs(collection(db, 'products'));
      const allProducts = snap.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');




      const familyFiltered = allProducts
        .filter(p => p.productFamily?.toLowerCase().replace(/\s+/g, '-') === resolvedFamilySlug)
        .sort((a, b) => {
          const rankA = parseInt(a.rank) || 9999;
          const rankB = parseInt(b.rank) || 9999;
          return rankA - rankB;
        });

        const topRankedProduct = familyFiltered.find(p => parseInt(p.rank) === 1);
        console.log('topRankedProduct', familyFiltered)
        setTopProductImage(topRankedProduct?.image || null);

      if (familyFiltered.length > 0) {
        setFamilyName(familyFiltered[0].productFamily);
      }

      const grouped = {};
      familyFiltered.forEach(p => {
        const sub = p.subFamily || 'Other';
        if (!grouped[sub]) grouped[sub] = [];
        grouped[sub].push(p);
      });

      setProducts(familyFiltered);
      setFilteredProducts(familyFiltered);
      setProductsBySubFamily(grouped);

      const uniqueFamilies = Array.from(new Set(familyFiltered.map(p => p.subFamily || 'Other')));
      setProductFamilies(uniqueFamilies);
    };

    fetchProducts();
  }, [resolvedFamilySlug]);

  useEffect(() => {
    if (activeFilter === 'All') {
      setFilteredProducts(products);
    } else {
      setFilteredProducts(products.filter(p => (p.subFamily || 'Other') === activeFilter));
    }
  }, [activeFilter, products]);

  const isFiberPanels = resolvedFamilySlug === "fiber-panels";

const handleFiberPanelJump = (filter) => {
  setActiveFilter(filter);
  setTimeout(() => {
    document.getElementById("fiber-panel-products")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, 50);
};


  if(!matchingFamilyText) return null

  return (
    <div className="product-family-page">
      {/* Homepage-style header */}
        <div className="curved-header" style={{ background: isMobile ? '#8CC540' : ''}}>
          {/* <div className='curved-header-left'> */}
          <center>
            <h1 style={{ fontSize: isMobile ? '3rem' : '' }} dangerouslySetInnerHTML={{ __html: superscriptRegistered(matchingFamilyText.headline || familyName) }} />
            </center>
            {/* </div> */}
            {/* <div className="curved-header-right">
              {topProductImage ? (
                <div className="square-image-wrapper">
                  <img
                    src={topProductImage}
                    alt="Top Ranked Product"
                  />
                </div>
              ) : (
                <div style={{ color: '#999' }}>No Image</div>
              )}
            </div> */}
        </div>

        {isFiberPanels ? (
          <>
            <section className="fp-intro-section">
              <div className="fp-intro-image">
                {topProductImage && <img src={topProductImage} alt="Fiber Panels" />}
              </div>

              <div className="fp-intro-text">
                <h2>Empower AI and Data Center Connectivity</h2>
                <p>
                  Go!Foton’s broad selection of fiber panels offers solutions for a wide variety
                  of network needs, including terminating, managing cables, organizing connections,
                  splicing, shuffling, and storing fibers. Whether you need a simple termination
                  point or a scalable high-density fiber management solution, Go!Foton has an
                  option designed to support your network infrastructure.
                </p>
              </div>
            </section>

            <section className="fp-icon-row">
              {FIBER_PANEL_CONFIG.heroIcons.map((item) => (
                <div className="fp-icon-card" key={item.label}>
                  <img src={item.icon} alt={item.label} />
                  <h3>{item.label}</h3>
                </div>
              ))}
            </section>

            <section className="fp-explore-section">
              <h2>Explore Go!Foton Fiber Panels</h2>
              <div className="fp-explore-buttons">
                {FIBER_PANEL_CONFIG.exploreFilters.map((filter) => (
                  <button key={filter} onClick={() => handleFiberPanelJump(filter)}>
                    {filter}
                  </button>
                ))}
              </div>
            </section>

            <section className="fp-description-section">
              <h2>Fiber panels enhance network security and efficiency</h2>

              <p>
                As the critical intermediary between trunks or interconnects and active equipment
                such as switches and routers, fiber panels play an essential role in maintaining
                efficient, reliable connectivity.
              </p>

              <ul>
                <li>Panels provide a secure location to protect, route, manage, and splice fragile fiber connections.</li>
                <li>Modular panel designs enable faster upgrades, simplified maintenance, and easier scalability.</li>
                <li>Organized fiber management improves airflow while minimizing cable stress in high-density environments.</li>
              </ul>

              <p>
                Go!Foton Fiber Panels deliver scalable, high-density connectivity that simplifies
                fiber management across{" "}
                <a href="/solutions/ai" target="_blank" rel="noreferrer">AI</a>,{" "}
                <a href="/solutions/datacenter" target="_blank" rel="noreferrer">data centers</a>,{" "}
                <a href="/solutions/fttx" target="_blank" rel="noreferrer">telecommunications, and CATV networks</a>.
              </p>

              <p>
                Our family of Fiber Panels combines modular scalability, growth flexibility, and
                robust fiber routing, with many featuring Go!Foton’s patented{" "}
                <a
                  href="https://gofoton.com/knowledge-center?doc=innovation-story-of-peacoc-technology"
                  target="_blank"
                  rel="noreferrer"
                >
                  PEACOC® Spreadable Adapter Technology
                </a>.
              </p>
            </section>

            <section className="fp-features-section">
              <h2>Signature Go!Foton fiber panel features</h2>
              <p>
                Engineered for long-term durability and maximum port density, Go!Foton Fiber Panels
                empower operators to streamline deployments, optimize uptime, improve cable
                organization, and confidently support future network growth.
              </p>

              <div className="fp-features-grid">
                {FIBER_PANEL_CONFIG.featureCards.map((card, idx) => (
                  <div className="fp-feature-card" key={idx}>
                    <img src={card.image} alt={card.title} />
                    <div className="fp-feature-caption">
                      <strong>{card.title}:</strong>
                      <span>{card.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </>
        ) : (
          <section className="product-introduction-section"
            style={{ position:'relative', display:'flex', alignItems:'center', gap: isMobile ? 16 : 32,
                    maxWidth:1200, margin:'0 auto', flexWrap: isMobile ? 'wrap' : 'nowrap',
                    overflow:'visible' }}           // ✅ make sure the section doesn’t clip
          >
            {/* LEFT: IMAGE COLUMN */}
          <div style={{ display:'flex', justifyContent:'flex-end', flex:'0 0 auto',
                          overflow:'visible', position:'relative', zIndex:2 }}>
              {topProductImage ? (
              <div className="square-image-wrapper"
                  style={{
                    width: isMobile ? 'clamp(220px, 70vw, 380px)' : 'clamp(260px, 28vw, 420px)',
                    aspectRatio:'1 / 1',
                    position:'relative',
                    marginRight: isMobile ? 0 : 50,
                    overflow:'visible',        // ✅ don’t clip the absolutely positioned imgs
                    zIndex:2                   // ✅ keep above the red text panel if needed
                  }}>

            {familyName === "Passive Optical Components" ? ( 
          <div
            style={{
              position: 'relative',
              width: '100%',
              maxWidth: '500px', // keep it from getting too huge on big screens
              margin: '-40px auto 0 auto',  // center horizontally
              aspectRatio: '1 / 1', // square container, stays responsive
            }}
          >
            <img
              src={topProductImage}
              alt="Top Ranked Product"
              style={{
                objectFit: 'contain',
                width: '65%',
                height: '65%',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            />
            <img
              src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2F10a.2-DWDM-100G-Spacing-Multi-Channel-v2.jpg?alt=media&token=d358f5cb-de2f-42d0-8452-74aec3909389"
              alt="Image"
              style={{
                objectFit: 'contain',
                width: '65%',
                height: '65%',
                position: 'absolute',
                bottom: 0,
                right: 0,
              }}
            />
          </div>




            
            ) :

            familyName === "Photodetectors" ? ( 
          <div
            style={{
              position: 'relative',
              width: '100%',
              maxWidth: '500px', // keep it from getting too huge on big screens
              margin: '-40px auto 0 auto',  // center horizontally
              aspectRatio: '1 / 1', // square container, stays responsive
            }}
          >
            <img
              src={topProductImage}
              alt="Top Ranked Product"
              style={{
                objectFit: 'contain',
                width: '65%',
                height: '65%',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            />
            <img
              src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2F9a.7-TAPD-Array-Unidirectional-Product-v2-300x300.jpg?alt=media&token=1bc1c387-702d-4361-95f2-99ddc2804066"
              alt="Image"
              style={{
                objectFit: 'contain',
                width: '65%',
                height: '65%',
                position: 'absolute',
                bottom: 0,
                right: 0,
              }}
            />
          </div>


            
            ):

            <img
              src={topProductImage}
              alt="Top Ranked Product"
              style={{
                objectFit: 'contain',
                width: '100%',
                height: '100%',
              }}
            />}
          </div>
                        ) : (
                          <div style={{ color: '#999' }}>No Image</div>
                        )}
                        </div>
                    <div className='product-introduction-section-right-text'>
                      <h2>{matchingFamilyText.subHeadline}</h2>
                      <p>
            {matchingFamilyText.bodyText.split('\n').map((line, i) => (
              <span key={i}>
                {line}
                <br /><br/>
              </span>
            ))}
          </p>       <div>
                    {familyName === "Lenses" && (
                      <a href="/knowledge-center?doc=selfoc-micro-lenses-tech-note-7-7-22" target="_blank" className="cta-button">View Tech Note</a>
                        
                    )}
                    </div>
                    </div>
                  </section>
        )}


                    {familyName === "Lenses" && !isMobile && (
  <div className="solutions-section-alignLeft table" style={{ marginTop: 50 }}>
    <div className="solutions-section-alignLeft-text-container">
      <h2 className="solutions-section-alignLeft-subheading">
        Wondering what lens is right for you?
      </h2>
      <p className="solution-section-alignLeft-description">
        Here are the primary applications by lens type.
      </p>
    </div>

    <table className="bead-table">
      <thead>
        <tr>
          <th>Lens Type</th>
          <th>Primary Applications</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Micro Lenses</td>
          <td>
            Beam coupling, fiber optics, compact optical assemblies, laser delivery systems
          </td>
        </tr>
        <tr>
          <td>Imaging Lenses</td>
          <td>
            Endoscopy, OCT systems, microscopy, machine vision, biomedical imaging/endoscopes,
            surveillance &amp; defense, metrology &amp; measurement
          </td>
        </tr>
        <tr>
          <td>Rod Lenses</td>
          <td>
            Relay imaging, borescopes, industrial inspection, medical imaging devices/endoscopy
          </td>
        </tr>
        <tr>
          <td>Neuroscience Lenses</td>
          <td>
            Single-photon microscopy, double-photon microscopy, neural imaging, in vivo research
          </td>
        </tr>
        <tr>
          <td>Lens Arrays</td>
          <td>
            Printing and scanning systems, 3D displays and cameras, consumer electronics,
            biomedical instrumentation, industrial applications, barcode scanners, machine vision systems
          </td>
        </tr>
      </tbody>
    </table>
  </div>
)}

      <section className="first-section" id="fiber-panel-products">
        <h2>{matchingFamilyText.subHeadline2}</h2>
        <div className="filtered-products-section">
          <div className="filter-buttons-bar">
            {['All', ...productFamilies].map((filter) => (
              <button
                key={filter}
                onClick={() => setActiveFilter(filter)}
                className={activeFilter === filter ? 'active' : ''}
              >
                {filter}
              </button>
            ))}
          </div>

          <div className="filtered-products-grid">
            {filteredProducts.map(product => (
              <div key={product.id} className="filtered-product-card">
                {product.image ? (
<div
  className="product-image-wrapper"
  style={{
    position: 'relative',
  }}
>
  {product.image ? (
    <img
      src={product.image}
      alt={product.product}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      }}
    />
  ) : (
                      <img
                  src={product.image && product.image.trim() !== "" ? product.image : "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/icons%2FGoFoton%20Placeholder.jpg?alt=media&token=94562a2e-50b7-4b8a-af28-381fd3bef222"}
                  alt={product.product}
                  className="product-image"
                />
                    )}
                  </div>
                ) : (
<img
                  src={product.image && product.image.trim() !== "" ? product.image : "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/icons%2FGoFoton%20Placeholder.jpg?alt=media&token=94562a2e-50b7-4b8a-af28-381fd3bef222"}
                  alt={product.product}
                  className="product-image"
                />
                )}
            <h3 dangerouslySetInnerHTML={{ __html: superscriptRegistered(product.product) }} />

                <a href={`/${product.id}`} className="learn-more">{isMobile ? 'View' : 'Learn More'}</a>
              </div>
            ))}
          </div>
        </div>

        </section>


        <div className="curved-footer-solutions">
          <div className="curved-top-overlay-product-family"></div>
          
          <h2>Would you like to hear more?</h2>
          <p>Our experts would love to hear about your systems and how we can help</p>
          <a className="connect-button" href="/contact-us">LET’S CONNECT</a>
        </div>
    </div>
  );
};

export default ProductFamilyPage;
